import React from 'react';
import ReactDOM from 'react-dom';
import './ConfirmationModal.css';

const ConfirmationModal = ({ isOpen, onConfirm, onCancel, title, message }) => {
  if (!isOpen) return null;

  const modalContent = (
    <div className="confirmation-modal-overlay">
      <div className="confirmation-modal-content">
        <h2 className="confirmation-modal-title">{title}</h2>
        <p className="confirmation-modal-message">{message}</p>
        <div className="confirmation-modal-actions">
          <button className="confirmation-modal-button confirmation-modal-cancel" onClick={onCancel}>
            Cancel
          </button>
          <button className="confirmation-modal-button confirmation-modal-confirm" onClick={onConfirm}>
            Delete
          </button>
        </div>
      </div>
    </div>
  );

  // Use Portal to render modal at document body level
  return ReactDOM.createPortal(modalContent, document.body);
};

export default ConfirmationModal;
